export default __webpack_public_path__ + "static/media/football.528f93aa.webp";